import { render, staticRenderFns } from "./attendancerecord.vue?vue&type=template&id=4ba6bb8c&scoped=true"
import script from "./attendancerecord.vue?vue&type=script&lang=js"
export * from "./attendancerecord.vue?vue&type=script&lang=js"
import style0 from "./attendancerecord.vue?vue&type=style&index=0&id=4ba6bb8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6bb8c",
  null
  
)

export default component.exports